import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import { statusQuery } from '../../../graph-ql/queries';
import { StatusResponse } from '../../models/status/status.response';

@Injectable()
export class StatusService {

  constructor(public apollo: Apollo) {
  }

  statusQuery$(): Observable<StatusResponse> {
    return this.apollo.query<StatusResponse>({
      query: statusQuery
    }).pipe(map(result => new StatusResponse({statuses: result.data['getStatuses']})));
  }
}
